/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Offset_AddInputs */

const en_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const fr_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const de_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const it_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungere`)
};

const ru_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлять`)
};

const es_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

const zh_cn2_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

const ja_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const hi_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ना`)
};

const pt_pt2_dialogue_list_export_offset_add = /** @type {(inputs: Dialogue_List_Export_Offset_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Dialogue_List_Export_Offset_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_offset_add = /** @type {((inputs?: Dialogue_List_Export_Offset_AddInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Offset_AddInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_offset_add(inputs)
	if (locale === "de") return de_dialogue_list_export_offset_add(inputs)
	if (locale === "it") return it_dialogue_list_export_offset_add(inputs)
	if (locale === "ru") return ru_dialogue_list_export_offset_add(inputs)
	if (locale === "es") return es_dialogue_list_export_offset_add(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_offset_add(inputs)
	if (locale === "ja") return ja_dialogue_list_export_offset_add(inputs)
	if (locale === "hi") return hi_dialogue_list_export_offset_add(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_offset_add(inputs)
	return en_dialogue_list_export_offset_add(inputs)
});